module.exports = __webpack_public_path__ + "static/media/delete.85061db2.svg";